import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "../../environments/environment";
import { Observable } from "rxjs";
import { WithholdingGroup } from "../models/withholding-group";
import { FilterWithholdingGroup } from "../models/filters/filter-withholdings-group";

@Injectable({
  providedIn: 'root'
})
export class WithholdingGroupService { 

  constructor(private http: HttpClient) { }

  private apiUrl = `${environment.apiUrl}`;
  private url: string = this.apiUrl + 'api/withholdingsGroup'; 

  findAllPageableWithholdingGroup(filterWithholdingGroup: FilterWithholdingGroup, page: number, pageSize: number): Observable<any> {
    return this.http.post<any[]>(`${this.url}/page/${page}/${pageSize}`, filterWithholdingGroup);
  }

  findWithholdingGroupById(id: number): Observable<WithholdingGroup> {
    return this.http.get<WithholdingGroup>(`${this.url}/${id}`);
  }

  createWithholdingGroup(withholdingGroup: WithholdingGroup): Observable<WithholdingGroup>{
    return this.http.post<WithholdingGroup>(this.url, withholdingGroup);
  }

  updateWithholdingGroup(withholdingGroup: WithholdingGroup): Observable<WithholdingGroup>{
    return this.http.put<WithholdingGroup>(`${this.url}/${withholdingGroup.id}`, withholdingGroup);
  }

}